import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Building2,
  UserPlus,
  BarChart3,
  Bell,
  ClipboardList,
  CreditCard,
  Layers,
  Settings,
  LogOut,
  Shield,
  Globe,
  Send,
} from 'lucide-react';
import useAuthStore from '@stores/authStore';

const navigation = [
  {
    section: 'Principal',
    items: [
      { name: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
      { name: 'Tenants', href: '/tenants', icon: Building2 },
      { name: 'Nuevo Tenant', href: '/tenants/new', icon: UserPlus, badge: 'Wizard' },
    ],
  },
  {
    section: 'Monitoreo',
    items: [
      { name: 'Analytics', href: '/analytics', icon: BarChart3 },
      { name: 'Alertas', href: '/alerts', icon: Bell },
      { name: 'Auditoría', href: '/audit-log', icon: ClipboardList },
    ],
  },
  {
    section: 'Administración',
    items: [
      { name: 'Planes', href: '/plans', icon: Layers },
      { name: 'Facturación', href: '/billing', icon: CreditCard },
      { name: 'Notificaciones', href: '/notifications', icon: Send },
      { name: 'Mapa GeoLeads', href: '/geoleads', icon: Globe, badge: 'Live' },
    ],
  },
  {
    section: 'Sistema',
    items: [
      { name: 'Configuración', href: '/settings', icon: Settings },
    ],
  },
];

export default function Sidebar() {
  const { logout, user } = useAuthStore();

  return (
    <aside className="w-64 bg-white border-r border-gray-200 flex flex-col">
      {/* Logo */}
      <div className="h-16 flex items-center gap-3 px-6 border-b border-gray-100">
        <div className="w-9 h-9 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-lg flex items-center justify-center">
          <Shield className="w-5 h-5 text-white" />
        </div>
        <div>
          <h1 className="font-semibold text-gray-900 text-sm">Terranova</h1>
          <p className="text-xs text-gray-500">Central Control</p>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto py-4 px-3 scrollbar-thin">
        {navigation.map((group) => (
          <div key={group.section} className="mb-6">
            <h3 className="px-3 mb-2 text-xs font-semibold text-gray-400 uppercase tracking-wider">
              {group.section}
            </h3>
            <ul className="space-y-1">
              {group.items.map((item) => (
                <li key={item.name}>
                  <NavLink
                    to={item.href}
                    className={({ isActive }) =>
                      `sidebar-link ${isActive ? 'active' : ''}`
                    }
                  >
                    <item.icon className="w-5 h-5" />
                    <span className="flex-1">{item.name}</span>
                    {item.badge && (
                      <span className="badge badge-blue text-[10px]">
                        {item.badge}
                      </span>
                    )}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>

      {/* User section */}
      <div className="p-3 border-t border-gray-100">
        <div className="flex items-center gap-3 p-3 rounded-lg bg-gray-50">
          <div className="w-9 h-9 bg-blue-100 rounded-full flex items-center justify-center">
            <span className="text-blue-600 font-semibold text-sm">
              {user?.name?.charAt(0) || 'A'}
            </span>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-gray-900 truncate">
              {user?.name || 'Admin'}
            </p>
            <p className="text-xs text-gray-500 truncate">
              {user?.email || 'admin@terranova.com'}
            </p>
          </div>
          <button
            onClick={logout}
            className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
            title="Cerrar sesión"
          >
            <LogOut className="w-4 h-4" />
          </button>
        </div>
      </div>
    </aside>
  );
}
